import React, { FC } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';
import { authPrefix } from 'routes/routes';

export interface PrivateRouteProps extends RouteProps {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  component?: any;
  navbar?: any;
  navbarBack?: boolean;
  navbarTitle?: string;
}

// create company, supervisor and common route (based on different access)
const PrivateRoute: FC<PrivateRouteProps> = ({
  component: Component,
  navbar: NavBar,
  navbarBack,
  navbarTitle,
  ...rest
}) => {
  const isAuthenticated = useSelector((state: RootState) => state.auth.authenticated);
  return (
    <Route
      {...rest}
      render={routeProps =>
        isAuthenticated ? (
          <>
            <NavBar title={navbarTitle} showBackBtn={navbarBack} />
            <div style={{ display: 'flex', flex: 1, flexDirection: 'column', padding: '40px' }}>
              <Component {...routeProps} />
            </div>
          </>
        ) : (
          <Redirect
            to={{
              pathname: `${authPrefix}/signin`,
              state: { from: routeProps.location }
            }}
          />
        )
      }
    />
  );
};

export { PrivateRoute };
